import axios from "axios";

export default {
  async getBOFormation(idFormation) {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        "/api/gestion/formations/" +
        idFormation
    );
    return response.data;
  },
  async getBOFormations() {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL + "/api/gestion/formations/"
    );
    return response.data;
  },
  async getFormationsSUAIO(idCampus) {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        "/api/suaio/formations/referent/campus/" +
        idCampus
    );
    return response.data;
  },
  async getFormationsEnseignant() {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        "/api/enseignant/formations/enseignant/"
    );
    return response.data;
  },
  async getFormationsScolarite(idCampus) {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        "/api/scolarite/formations/" +
        idCampus
    );
    return response.data;
  },
  async getTypesDiplomes() {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL + "/api/typesDiplomes"
    );
    return response.data;
  },
  async getFormationsParTypeDiplome(idTypeDiplome) {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        "/api/typesDiplomes/" +
        idTypeDiplome +
        "/formations"
    );
    return response.data;
  },
  async getFormation(idFormation) {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL + "/api/formations/" + idFormation
    );
    return response.data;
  },
  async getTypesPieces() {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL + "/api/typesPieces"
    );
    return response.data;
  },
  async updateFormation(formation) {
    const response = await axios.put(
      process.env.VUE_APP_BACKEND_API_URL +
        "/api/gestion/formations/" +
        formation.id,
      formation
    );
    return response.data;
  },
  async ajoutFormation(formation) {
    const response = await axios.post(
      process.env.VUE_APP_BACKEND_API_URL + "/api/admin/formations",
      formation
    );
    return response.data;
  },
  async supprimerFormation(idFormation) {
    const response = await axios.delete(
      process.env.VUE_APP_BACKEND_API_URL +
        "/api/admin/formations/" +
        idFormation
    );
    return response.data;
  },
  async getFormations() {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL + "/api/formations"
    );
    return response.data;
  },
  async getFormationsCsv() {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL + "/api/gestion/csv/formations"
    );
    return response.data;
  },
  async getFormationsREO(idTypeDiplome) {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL +
        "/api/formationsREO/" +
        idTypeDiplome
    );
    return response.data;
  },
  async getNiveauxFormations() {
    const response = await axios.get(
      process.env.VUE_APP_BACKEND_API_URL + "/api/formations/niveaux"
    );
    return response.data;
  }
};
